import { ViewerComponent } from '@app/client/viewer/viewer.component';

export const VIEWER_ROUTES = [
  {
    path: '',
    data: { moduleName: 'ViewerModule' },
    component: ViewerComponent,
  },
];
